var _a, _b;
export const isOpenUI = !!((_b = (_a = window === null || window === void 0 ? void 0 : window.sas) === null || _a === void 0 ? void 0 : _a.ltjs) === null || _b === void 0 ? void 0 : _b.isOpenUI);
